import { createGlobalStyle } from 'styled-components';

// Fixing issue with ButtIcons clashing with the monoliths `padding: 0` on every element
// Using the classname instead of component reference due to different versions floating around
// - Tooltip z-index adjusted as a more recent of the component has changed its value,
//   the transition is disabled as the z-index only applies after the opacity transition.
export const MonolithCSSOverrides = createGlobalStyle`
  & .hpn-Butticon {
    padding: 1px 6px 1px 6px;

    // Fixes issue with Chrome giving massive icons
    .hpn-Icon {
      flex-direction: column;
    }
  }

  #tooltip {
    transition: none;
    z-index: 401;
  }

`;
